/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useGetIncomingEventQuery } from "~/generated/graphql";

type Props = {
  eventId: string;
};

export function useGetIncomingEvent({ eventId }: Props) {
  const { data, loading, error } = useGetIncomingEventQuery({
    variables: {
      id: eventId,
    },
  });

  return { event: data?.incomingEvent ?? undefined, loading, error } as const;
}
